(function () {
  var sticky = document.querySelector('.adv-sticky, .adv2-sticky');
  var bar = document.querySelector('.adv-progress__bar, .adv2-progress__bar');

  if (!sticky && !bar) return;

  function onScroll() {
    var y = window.scrollY;
    if (sticky) sticky.classList.toggle('is-visible', y > 500);
    if (bar) {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (docH > 0 ? (y / docH) * 100 : 0) + '%';
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
